import { CSSProperties, memo } from 'react';
import cls from 'classnames';

import { isLightColor } from '@/common/helpers/isLightColor';
import { MEDIA_SIZE_80 } from '@/media/constants/sizes';

import styles from './RenderLabel.module.css';

interface RenderLabelProps {
  mediaSize: number;
  bgColor?: Nullable<string>;
  isCompact?: boolean;
  isExpandable?: boolean;
  className?: string;
}

function RenderLabel(props: RenderLabelProps) {
  const { mediaSize, bgColor, isCompact = false, isExpandable = true, className } = props;

  const isCollapsed = isCompact || mediaSize < MEDIA_SIZE_80;
  const style = { '--render-label-media-size': mediaSize } as CSSProperties;

  return (
    <span
      className={cls(
        styles.renderLabel,
        {
          [styles.renderLabelCompact]: isCollapsed,
          [styles.renderLabelExpandable]: isCollapsed && isExpandable,
          [styles.renderLabelOnLight]: !!bgColor && isLightColor(bgColor),
        },
        className,
      )}
      style={style}
      aria-label="Render label"
    >
      R<span className={styles.renderLabelRest}>ender</span>
    </span>
  );
}

export default memo(RenderLabel);
